import React from 'react';
import PropTypes from 'prop-types';
import AppTableContainer from '../../../../@crema/core/AppTableContainer';
import BlogActions from './BlogActions';
import {Switch} from 'antd';
import {useDispatch} from 'react-redux';
import {updateBlog} from 'redux/actions/Blog';
import {DateFormat} from 'shared/constants/AppEnums';
import moment from 'moment';

const BlogTable = ({propertyData}) => {
  const dispatch = useDispatch();

  const handleChange = (checked, record) => {
    // dispatch(updateBlogStatus(record?.id));
  };

  const columns = [
    {
      title: 'Banner Image',
      dataIndex: 'bannerImageUrl',
      key: 'bannerImageUrl',
      render: (_, record) => {
        return (
          <img
            src={record?.bannerImageUrl}
            width={50}
            height={40}
            alt='blog banner image'
          />
        );
      },
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'shortDescription',
      key: 'shortDescription',
      render: (_, record) => {
        return record?.shortDescription?.length > 35
          ? `${record.shortDescription.substring(0, 35)}...`
          : record.shortDescription;
      },
    },
    {
      title: 'Order',
      dataIndex: 'order',
      key: 'order',
      render: (_, record) => {
        return <>{record?.order || '-'}</>;
      },
    },
    {
      title: 'Active/In Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (_, record) => {
        return <>{record?.isActive ? 'Active' : 'In Active'}</>;
      },
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
    },
    {
      title: 'Published On',
      dataIndex: 'publishedOn',
      key: 'publishedOn',
      render: (_, record) => {
        return (
          <>
            {' '}
            {moment(
              record.publishedOn ? record.publishedOn : record.createdAt,
            ).format(DateFormat.ONLY_DATE_WITH_SLASH)}
          </>
        );
      },
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      className: 'customer-table-actions',
      fixed: 'right',
      render: (_, record) => {
        return <BlogActions data={record} />;
      },
    },
  ];

  return (
    <AppTableContainer
      className='customer-table'
      hoverColor
      data={propertyData}
      columns={columns}
      scroll={{x: 'auto'}}
    />
  );
};

export default BlogTable;

BlogTable.defaultProps = {
  propertyData: [],
  loading: false,
};

BlogTable.propTypes = {
  propertyData: PropTypes.array,
  loading: PropTypes.bool,
};
